import InitMiddleware from "./middlewares/initMiddleware";

export default InitMiddleware